import React from "react";
import "./Header.css";

type Props = {
  children?: React.ReactNodeArray | React.ReactNode;
  style?: React.CSSProperties;
};

const filterHeaderChild = (children: React.ReactNodeArray | React.ReactNode) => {
  let leftComponents: React.ReactNodeArray = [];
  let rightComponent: React.ReactNode = undefined;

  React.Children.forEach(children, (node) => {
    const element = node as React.ReactElement;
    if (element) {
      if (element.type === rightSide) {
        rightComponent = node;
      } else {
        leftComponents.push(node);
      }
    }
  });

  return [leftComponents, rightComponent];
};

const Header = ({ children, style = {} }: Props) => {
  const [leftComponent, rightComponent] = filterHeaderChild(children);

  return (
    <div
      className="main-header-container"
      style={{
        ...style,
      }}
    >
      <div className="main-header-title">
        <span className="main-header-instrument-type">ROCK IMAGER</span>
        <span className="main-header-instrument-type-r">{"\u00AE"}</span>
        {leftComponent}
      </div>
      {rightComponent}
    </div>
  );
};

const rightSide = ({ children, style = {} }: Props) => {
  return <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>{children}</div>;
};

Header.RightSide = rightSide;

export default Header;
